import React from "react";
import ApplicationsManagement from "./ApplicationsManagement";

const CandidateGridView: React.FC = () => {
  return <ApplicationsManagement viewMode="grid" />;
};

export default CandidateGridView;
